import { IConditionalVoucherDiscount } from './ConditionalVoucherDiscount';
import { IVoucherDiscount } from './VoucherDiscount';

export const isConditionalDiscount = (
  discount: IConditionalVoucherDiscount | IVoucherDiscount
): discount is IConditionalVoucherDiscount => {
  return discount && 'discountConditions' in discount;
};
